<template>
	<el-aside :width="(isCollapse ? '64px' : '250px')">
		<el-menu
			@select="handleSelect"
			:default-active="activeIndex"
			class="el-menu-custom"
			:collapse="isCollapse"
			background-color="#f8f8f8"
			text-color="#181C20"
			active-text-color="#8f0ced">
			<div class="logo">
				<a href="#" class="simple-text" >
					<div class="logo-img" >
						<img src="/static/img/logo_gnet.png" alt="">
					</div>
				</a>
			</div>
			<template v-if="isAdmin">
				<el-menu-item v-if="currentUser.rol == 1" index="Usuarios" @click="cambio('/dashboard/usuarios')" exact>
					<i class="ionicons ion-ios-people"></i>
					<span slot="title">Gestión de usuarios</span>
				</el-menu-item>
				<el-menu-item index="Informes" @click="cambio('/dashboard/proyectos')" exact>
					<i class="ionicons ion-ios-list-outline"></i>
					<span slot="title">Gestión de proyectos</span>
				</el-menu-item>
				<!-- <hr />				 -->
			</template>
			<template v-if="!isAdmin">
				<el-menu-item index="Usuarios" @click="cambio('/dashboard/misinformes')" exact>
					<i class="ionicons ion-ios-list-outline"></i>
					<span slot="title">Mis informes</span>
				</el-menu-item>
				<!-- <hr /> -->
			</template>
			<el-menu-item v-if="showSidebar" v-for="(link ,index) in links" :key="index" :index="link.id" @click="cambio('/dashboard/informe/' + link.id)" exact>
				<i :class="link.icono"></i>
				<span slot="title">{{ link.nombre }}</span>
			</el-menu-item>

			<el-menu-item index="1" @click="desconectar" class="menu__custom-logout">
				<i class="ionicons ion-ios-locked-outline"></i>
				<span class="item--custom">{{currentUser.name}}</span>
				<span slot="title">Logout</span>
			</el-menu-item>			
		</el-menu>
	</el-aside>
</template>
<script>
	import ApiService from '@/common/api.service'
	import { mapGetters, mapState } from "vuex";
    import { FECTH_SIDEBAR, FECTH_SHOW_SIDEBAR, LOGOUT } from "@/store/actions.type";

	export default {
		name: "sidebar",
		computed: {
			...mapGetters(['isAdmin', 'currentUser', 'getSidebar', 'getShowSidebar'])
		},
		created () {
			this.$route.params.informe_id ? this.activeIndex = this.$route.params.informe_id : this.activeIndex = this.$route.name
            this.$root.$on('sidebar', (id)=> {
				window.localStorage.setItem('analiticaproyectoActivo', id)
				this.project_id = id
				this.showSidebar = false
				this.init()
			})
			setTimeout(() => {
				if(window.localStorage.getItem('analiticaproyectoActivo')){
					this.project_id = window.localStorage.getItem('analiticaproyectoActivo')
					this.showSidebar = false
					this.init()
				} 
			}, 500);
			setTimeout(() => { this.isCollapse = this.getShowSidebar }, 500);
			this.$root.$on("toogleChange", ()=> { this.toggle()})
		},
		data() {
			return {
				links: null,
				isCollapse: true,
				activeIndex: 'informes',
				project_id: null,
				showSidebar: false
			}
		},
		watch: {
			$route: function(newRoute, oldRoute) {
				this.$router.go(this.$router.currentRoute)
			}
		},
		methods: {
			init() {
				this.getReports()
				setTimeout(() => {
					this.showSidebar = true
				}, 500);
			},
			findActiveLink() {
				if (localStorage.getItem("analiticauser")) {
					let obj = localStorage.getItem("analiticatoken");
				}
			},
			cambio(href) {
                this.$root.$emit('isConnect')    
                this.$router.push(href)
			},
			toggle() {
				this.isCollapse = !this.isCollapse;
			},
			async getReports(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: false,
                    method: 'SELECT',
                    fields: [
						'informes.id',
						'informes.icono',
						'informes.url',
						'informes.nombre',
						'informes.descripcion'
					],
                    inner: [
						'reports_projects, report_id, id, informes',
					],
                    where: ' informes.visible = 1 AND reports_projects.project_id = ' + this.project_id,
					table: 'informes',
					groupby: ' informes.id',
					order: [' informes.order_row']
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.links = response.data
                    }
                    setTimeout(() => { this.loading = false }, 200);
                })
			},
			handleSelect(key, keyPath) {


			},
			desconectar() {
				this.$store.dispatch(LOGOUT).then(() => {
					this.$router.go('/login');
					window.localStorage.removeItem('analiticaproyectoActivo')
				});
			}
		},
		mounted() {
			this.findActiveLink();
			this.table = this.$route.params.db;
		}

	};
</script>
<style lang="scss" scoped>
	.el-aside,
	.el-menu {
		min-height: calc(100vh);
		height: calc(100vh);
		width: 80px;
		background: rgb(248, 248, 248);
		border-right: 1px solid rgb(231, 231, 231);
		left: 0px;
		top: 0px;
		position: fixed;
		z-index: 999;
		transition: all 0.2s linear;
	}
	.el-menu-custom {
		border-right: none;
	}
	.logo {
		// height: 60px;
		height: 90px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		position: relative;
		padding-top: 10px;
    	padding-bottom: 10px;
		&:before {
			content: "";
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translate(-50%, 0);
			height: 1px;
			width: 90%;
			background: white;
		}
		> .simple-text {
			color: white;
			font-weight: 700;
			> .logo-img {
				display: inline-block;
				> img {
					max-width: 100%;
				}
			}
		}
		.close {
			width: 64px;
		}
	}
	.el-menu-custom  i {
		color: #181C20 !important
	}

	.el-menu-item .ionicons, 
	.el-menu-item .fa {
    	width: 100%;
		text-align: center;
		font-size: 24px !important;
		vertical-align: middle;
	}
	.el-menu-item{
		&.is-active {
			background-color: rgb(198, 198, 198) !important;
		}
	}
	hr {
		margin: 0;
	}
	.menu__custom-logout {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 80px;
	}
	.item--custom {
		display: block !important;
		visibility: visible !important;
		height: 100% !important;
		width: 100% !important;
		font-size: 12px;
		bottom: -35px;
		position: absolute;
		left: 0;
		margin-top: 10px;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Sidebar.vue